module.exports = __webpack_public_path__ + "static/6-e1af4c001fe998fb198b36bdf5ecc8c0.jpeg";